import { render, staticRenderFns } from "./WarrantyRepairBox.vue?vue&type=template&id=4f997c92"
import script from "./WarrantyRepairBox.vue?vue&type=script&lang=js"
export * from "./WarrantyRepairBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports